<template>
  <div>
    <h4>{{ data.title }} <span class="text-success">({{ descriptionType }})</span></h4>

    <div class="mb-4" v-if="data.description">
      <div v-html="data.description"/>
    </div>

    <div v-if="data.metadata.variants.length">

      <div v-for="(variant, k) in data.metadata.variants" style="margin-bottom: 2rem;">
        <div style="font-size: 15px;" v-html="variant.description"></div>
        <h6 class="my-2">Ответы:</h6>

        <ul>
          <li v-for="(answer, k) in variant.answers" :key="k">
            <div :class="`questions-test ${answer.is_true ? 'true' : ''}`">
              <div v-if="answer['img']" class="questions-test-img">
                <img :src="answer['img']"/>
              </div>
              <div class="questions-test-title">
                <h6>{{ k + 1 }}. {{ answer["title"] }}</h6>
                <span v-if="answer.is_true" class="badge badge-success">Правильный</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import RichEditor from "@/components/Editor/RichTextEditor.vue";

export default {
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [],
        },
        readOnly: true,
        theme: "snow",
      },
    };
  },
  props: ["data", "descriptionType"],
  components: {
    RichEditor,
  },
  methods: {
    focus(event) {
      event.enable(false);
    },
  },
};
</script>
